<template>
  <v-app>
    <v-content class="content white">
      <router-view class="pa-0"></router-view>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import jj from 'jwt-decode'
export default {
  name: "App",

  created() {
    //console.log('aaaaaaaa', jj(this.jwt))
    // if (this.$route.name != "caseDetails") {
    //   if (!this.jwt) {
    //     this.$router.push({ path: "/index" });
    //   } else {
    //     console.log(this.role)
    //     if (this.role == "self") {
    //       this.$router.push({ path: "/selfService/dashboard" });
    //     } else if (this.role == "front") {
    //       this.$router.push({ path: "/frontDesk/dashboard" });
    //     } else if (this.role == "company") {
    //       this.$router.push({ path: "/company/dashboard" });
    //     }
    //   }
    // }
  },
  computed: {
    ...mapState({
      jwt: state => state.auth.jwt
    }),
    ...mapGetters(["role"])
  },

  data: () => ({
    //
  })
};
</script>

<style lang="scss">
.content {
  background-color: rgb(244, 244, 244);
}
.container {
  min-height: 100vh;
}
.cell {
  background-color: rgb(255, 255, 255);
  -webkit-box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 2px 13px 0px rgb(0, 0, 0, 0.1);
}
.buttonText {
  text-transform: none !important;
  letter-spacing: normal !important;
}

.light {
  color: var(--v-gray-base);
}

.dark {
  font-weight: 500;
}

.list {
  list-style: none;
  padding: 0 !important;
}

.listItem {
  cursor: pointer;
  margin-top: 20px;
  padding: 0 0;
  height: 40px;
  display: flex;
  align-items: center;

  .active {
    box-shadow: 5px 0px 0px var(--v-primary-base) inset;
  }
}

.table {
  border-collapse: collapse;
}

.tableRowHead {
  background-color: rgb(249, 249, 249);
  height: 60px;
}

.tableRowData {
  height: 60px;
  border-bottom: 1pt solid rgb(247, 247, 247);
}

.tableHead {
  width: 200px;
}

.tab {
  text-transform: none !important;
  letter-spacing: normal !important;
  color: black !important;
  font-size: 16px !important;
}

.wrapper {
  min-height: calc(100vh - 64px);
  background-color: white;
}

.logos {
  img {
    width: 160px;
    height: auto;
    margin-right: 20px;
  }
}

.dn2me-logo {
  margin-bottom: 10px;
  img {
    height: 50px;
  }
}
.headerImg {
  height: 60px;
}
</style>
